import React from 'react';
import { makeStyles } from '@mui/styles';

const WrappedStyles = ({ Component, ...props }) => {
  const classes = props.classes;
  return <Component {...props} styles={classes} />;
};

const withStyles = styles => Component => props => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return <WrappedStyles {...props} classes={classes} Component={Component} />;
};

export default withStyles;
